import { OpenInNewIcon } from "@dotnet/telematics-design-system";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";

import { LinkProps } from "./types";

const Link = ({ children, href }: LinkProps) => {
    return (
        <TextLink
            size={TEXT_LINK_SIZES.Normal}
            target="_blank"
            href={href}
            icon={<OpenInNewIcon />}
        >
            {children}
        </TextLink>
    );
};

export { Link };
